import locationsConfiguration from '@config/matchmaker/locations';
import { useMemo } from 'react';

export default function useClusteredLocations(locations) {
  return useMemo(
    () =>
      locationsConfiguration.map(({ id, title, codes }) => ({
        id,
        title,
        locations: locations.filter(location => codes.includes(location.code)),
      })),
    [locations]
  );
}
